import { Component} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/Service/auth.service';
import { GlobalConstants } from 'src/app/utils/global-constants';
import { NotificationService } from 'src/app/Service/notification.service';

@Component({
    selector: 'app-newslatterspopup',
    templateUrl: './newslatterspopup.component.html',
    styleUrls: ['./newslatterspopup.component.css'],
    standalone: false
})
export class NewslatterspopupComponent {
  mainpopup: boolean = true;
  successpopup: boolean;

  submitform = new FormGroup({
    firstname: new FormControl('', [
      Validators.required,
      Validators.pattern(GlobalConstants.firstnamePattern),
    ]),
    lastname: new FormControl('', [
      Validators.required,
      Validators.pattern(GlobalConstants.firstnamePattern),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(GlobalConstants.emailPattern),
    ]),
  });

  constructor(
    public dialog: NgbModal,
    public auth: AuthService,
    private notify: NotificationService
  ) {}

  submit() {
    try {
      if (this.submitform.valid) {
        const data = {
          firstname: this.submitform.value.firstname,
          lastname: this.submitform.value.lastname,
          email: this.submitform.value.email,
        };

        this.auth.NewsLetterUserSignUp(data).subscribe((res) => {
          if (res) {
            this.mainpopup = false;
            this.successpopup = res?.data;
            if (res?.succeeded === false) {
              this.notify.showError('This Email was already Exist.');
              this.mainpopup = true;
            }
          }
        });
      }
    } catch (error) {
      console.error('An error occurred in submit:', error);
    }
  }
}
